// extracted by mini-css-extract-plugin
export default {"button":"Ww","primary":"Xw","fullWidth":"Yw","secondary":"Zw","nutrition":"ax","underlined":"bx","small":"cx","medium":"ex","info":"fx","white":"gx","border":"hx","mango":"ix","charcoal":"jx","court":"kx","green":"lx","spark":"mx","linkButton":"nx","disabled":"ox"};
    if(module.hot) {
      // 1737143654491
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  